import { Pipe, PipeTransform } from "@angular/core";
import { ADMINISTRATOR_ROLE, DIGI_ROLE, HELPER_ROLE, ORGANIZER_ROLE, USER_ROLE } from "@model";
import { TranslocoService } from "@ngneat/transloco";

@Pipe({ name: 'role' })
export class RolePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (role?: string) => this.getRoleTitle(role);

  private getRoleTitle = (role?: string): string => {
    const roles = {
      [ORGANIZER_ROLE]: "app.common.role.organiser",
      [ADMINISTRATOR_ROLE]: "app.common.role.admin",
      [USER_ROLE]: "app.common.role.user",
      [HELPER_ROLE]: "app.common.role.helper",
      [DIGI_ROLE]: "app.common.role.digi"
    };
    return this.translocoService.translate(role ? roles[role] : "-");
  }
}
